(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ona-product-assurance"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(e){var b=e.target.closest&&e.target.closest('[data-ona-scroll-order]');if(!b)return;var selectors=['[id*="easysell" i]','[class*="easysell" i]','shopify-app-block'];var target=null;for(var i=0;i<selectors.length&&!target;i++){var all=document.querySelectorAll(selectors[i]);for(var j=0;j<all.length;j++){if(!all[j].closest('.ona-product-assurance')){target=all[j];break}}}if(target){target.scrollIntoView({behavior:'smooth',block:'center'})}else{window.scrollTo({top:0,behavior:'smooth'})}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ona-v2-essai"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ona-v2]').forEach((section) => {
    const variants = JSON.parse(section.querySelector('[data-v2-variants]').textContent);
    section.querySelectorAll('.v2-options input').forEach((input) => {
      input.addEventListener('change', () => {
        const choices = [...section.querySelectorAll('.v2-options')].map((group) => group.querySelector('input:checked').value);
        const variant = variants.find((item) => item.options.every((value, index) => value === choices[index]));
        if (!variant) return;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        url.hash = 'v2-order';
        window.location.assign(url.href);
      });
    });
    const main = section.querySelector('.v2-main-image');
    section.querySelectorAll('.v2-thumbnail').forEach((button) => {
      button.addEventListener('click', () => {
        main.src = button.dataset.image;
        main.removeAttribute('srcset');
        section.querySelectorAll('.v2-thumbnail').forEach((item) => {
          item.classList.toggle('is-selected', item === button);
          item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ona-warroom-home"] && !Shopify.designMode) return;
  try {
    
(async () => {
const { Component } = await import('@theme/component');
class OnaHomeCarousel extends Component {
  #controller;
  connectedCallback() {
    super.connectedCallback();
    this.#controller = new AbortController();
    const options = { signal: this.#controller.signal };
    this.addEventListener('click', this.#navigate, options);
    this.refs.track?.addEventListener('scroll', this.#update, { ...options, passive: true });
    this.#update();
  }
  disconnectedCallback() { this.#controller?.abort(); super.disconnectedCallback(); }
  #navigate = (event) => {
    const button = event.target.closest('button[data-direction]');
    const track = this.refs.track;
    if (!button || !track) return;
    const slides = this.refs.slides || [];
    const current = Math.round(track.scrollLeft / track.clientWidth);
    const next = (current + Number(button.dataset.direction) + slides.length) % slides.length;
    track.scrollTo({ left: next * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  };
  #update = () => {
    const track = this.refs.track;
    const slides = this.refs.slides || [];
    if (!track || !this.refs.status) return;
    const current = Math.round(track.scrollLeft / track.clientWidth);
    this.refs.status.textContent = (current + 1) + ' / ' + slides.length;
    slides.forEach((slide, index) => { slide.inert = index !== current; });
  };
}
if (!customElements.get('ona-home-carousel')) customElements.define('ona-home-carousel', OnaHomeCarousel);
})();

  } catch(e) { console.error(e); }
})();
})();
